import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { Modal } from '@storable/canaveral-components';
import Button from '../../../../../modules/react/components/stateless/Button';

const propTypes = {
  onCancelEdit: PropTypes.func.isRequired,
  onFinishEdit: PropTypes.func.isRequired,
  corp: PropTypes.string,
  site: PropTypes.string,
};

const defaultProps = {
  corp: undefined,
  site: undefined,
};

class Editor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      corp: props.corp || '',
      site: props.site || '',
    };
  }

  onCorpChange = e => this.setState({ corp: e.target.value });

  onSiteChange = e => this.setState({ site: e.target.value });

  finishEdit = () => {
    const { onFinishEdit } = this.props;
    const { corp, site } = this.state;
    const content = '<div id="rapidstor-base"><div id="rapidstor-app"></div></div>';

    onFinishEdit({ content, corp, site });
  };

  render() {
    const { onCancelEdit } = this.props;
    const { corp, site } = this.state;

    return (
      <Modal
        show
        onDismiss={onCancelEdit}
        aria-labelledby="standard-unit-listing-editor-modal"
      >
        <Modal.Header>
          <Modal.Title id="standardunitlisting">Standard Unit Listing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <React.Fragment>
              <Form.Text className="text-muted">
                Use the token values from Rental {"Center's"} code snippets page to fill in this form.
              </Form.Text>
              <Form.Label>
                Corp Token:
              </Form.Label>
              <Form.Group>
                <Form.Control
                  as="input"
                  value={corp}
                  onChange={this.onCorpChange}
                />
              </Form.Group>
              <Form.Label>
                Site Token:
              </Form.Label>
              <Form.Group>
                <Form.Control
                  as="input"
                  value={site}
                  onChange={this.onSiteChange}
                />
              </Form.Group>
            </React.Fragment>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={onCancelEdit}>Cancel</Button>
          <Button variant="success" onClick={this.finishEdit}>Save</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

Editor.propTypes = propTypes;
Editor.defaultProps = defaultProps;

export default Editor;
